"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = fetchRelatedProperties;
async function fetchRelatedProperties(request) {
    const response = await fetch(`/api/leads/related/${request.type}/${request.propertyId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            email: request.email,
            limit: request.limit || 2
        })
    });
    return response.json();
}
//# sourceMappingURL=fetchRelatedProperties.js.map